import { getAuthToken } from './auth/tokenStorage';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { API_URL } from '../config';

export interface TaskStatus {
  status: 'not_started' | 'in_progress' | 'completed';
}

class TasksService {
  private async getAuthToken(): Promise<string | null> {
    return await getAuthToken();
  }

  private async makeRequest(endpoint: string, options: RequestInit = {}): Promise<Response> {
    const token = await this.getAuthToken();
    
    const response = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers,
      },
    });

    return response;
  }

  async completeTask(taskKey: string): Promise<TaskStatus> {
    const response = await this.makeRequest(`/api/tasks/${taskKey}/complete`, {
      method: 'POST',
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Failed to complete task: ${response.status}`);
    }
    
    return await response.json();
  }

  async resetTask(taskKey: string): Promise<TaskStatus> {
    const response = await this.makeRequest(`/api/tasks/${taskKey}/reset`, {
      method: 'POST',
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Failed to reset task: ${response.status}`);
    }
    
    return await response.json();
  }

  async getTaskStatus(taskKey: string): Promise<TaskStatus> {
    const response = await this.makeRequest(`/api/tasks/${taskKey}/status`);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Failed to get task status: ${response.status}`);
    }
    
    return await response.json();
  }
}

export const tasksService = new TasksService();